import React from 'react';
import {SHOW_LOADER} from 'utils/constants';
 
class Preloader extends React.Component {
    constructor(props) {
        super(props);
        this.state = {isLoading: false};
        //this.handlePathChange = this.handlePathChange.bind(this);    
        this.toggleLoader = this.toggleLoader.bind(this);    
        const ev = {};
        ev[SHOW_LOADER] = this.toggleLoader;
        app.events.subscribe(ev);
    }
    toggleLoader(params){
        params = params && params.constructor == Array?params[0]:params;
        app.loaderCount += params.status ? 1 : -1;
        // console.error(params.status + '--' + app.loaderCount)
        // false + loadercount=-1=false, true + loaderCount=1=true, //otherwise the state doesnt have to be changed
        if ((!params.status && app.loaderCount === -1) || (params.status && app.loaderCount === 1) || app.loaderCount === 0) {
            // console.error('status changed to ' + params.status)
            this.setState({isLoading: params.status});
            params.status ? document.body.classList.add('loading'): document.body.classList.remove('loading');
        }
    }
    
    render(){
        return(
            <React.Fragment>
                {!this.state.isLoading && <React.Fragment/>}
                {this.state.isLoading && <div className="bg-loader">
                                            <div className="loader"></div>
                                        </div>}
            </React.Fragment>
            // <div className={this.props.class}>               
            // </div>
        )
    }
}
export default Preloader;